import { BudgetAPI } from "@griffingroupglobal/eslib-api";
import { BUDGET_COST_PLUS } from "../../../../constants";

const convertToCostPlusBudgetHandler = async (props) => {
  const { oldBudgetType, budgetLastUpdated, budgetId } = props;

  const response = await BudgetAPI.patch(
    budgetId,
    { budgetType: BUDGET_COST_PLUS },
    { budgetType: oldBudgetType },
    { date: budgetLastUpdated }
  );

  return response.data;
};

export default convertToCostPlusBudgetHandler;
